// lib
import React from 'react'
import { RouteComponentProps } from 'react-router'

// components
import LoadingSpinner from 'src/components/loading_spinner/loading_spinner'
import MetaTags from 'src/components/meta_tags/meta_tags'
import StandardPageTitle from 'src/containers/smart_components/page_title/page_title'
import LayoutNoMap from 'src/layout/layout_no_map'

// constants & interfaces
import { TWO_COLUMNS } from 'src/constants/layout'
import { CREATE_PROFILE_TITLE } from 'src/constants/meta_tags'
import { textResources } from 'src/lang/de'

// helpers
import { usePageTracking } from 'src/pages/hooks/hooks'
import { useSelectUser } from 'src/reducers/user/user_hooks'

// webpack magic comment inside dynamic import to name outputted chunk see:
// https://webpack.js.org/guides/code-splitting/#dynamic-imports
const CreateProfile = React.lazy(() =>
  import(/* webpackChunkName: "create-profile-page" */ 'src/containers/create_profile'))

const CreateProfilePage: React.FC<RouteComponentProps> = () => {
  const user = useSelectUser()

  usePageTracking({ user })

  return (
    <>
      <MetaTags
        title={CREATE_PROFILE_TITLE}
      />
      <LayoutNoMap
        contentWidth={TWO_COLUMNS}
        pageTitle={<StandardPageTitle text={textResources.pageTitles.addProfile} />}
      >
        <React.Suspense fallback={<LoadingSpinner shown />}>
          <CreateProfile/>
        </React.Suspense>
      </LayoutNoMap>
    </>
  )
}

export default CreateProfilePage
